import React, { useState } from "react";
// import CardModal from "../Component/CardModal";
import { toast ,ToastContainer} from "react-toastify";

import CardModal from "../../Components/CardSwipeModal";
const CardSwipe = () => {
    

    return (
        <div> 
           <CardModal />
           <ToastContainer/>
        </div>
    );
};

export default CardSwipe;